export function generateEvidenceRef() {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16);
    if (c === 'x') {
      return r.toString(16);
    }

    return (8 + Math.floor(Math.random() * 4)).toString(16);
  });
}
